import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { getReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class RevenueReports extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'REVENUE_REPORTS',
      path: ["Home", "Revenue Report"],
      links: ["home", "report/revenue"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      catID: "",
      merchantTypeID: "",
      dealType: "",
      sales: [],
      isLoading: "false",
      csvData: "",
      reportData: "",
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => this.setState({ startDate: date });
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          dealType: this.state.dealType,
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          dealType: this.state.dealType,
        };
      }

      this.props.getReport(formData, 'report/revenue-reports');
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMerchantType();
    this.props.getAllCategorys({page:0});
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      if(siteData.combine_products == 'disable') {
        this.setState({dealType: 'offer'});
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'),dealType: 'offer',}, 'report/revenue-reports')
      }else{
        this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD'),dealType: '',}, 'report/revenue-reports')
      }
    }    
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantType: nextProps.merchantType });
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        this.setState({ catData: nextProps.catData.data });
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ reportData: nextProps.reportData });
        this.handleExport(nextProps.reportData);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

    handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
          'Market',
          'Credit Card Sales',
          'Site Credits',
          'Promos',
          'Gross Sale',
          'Taxes',
          'Credit Card Fee',
          'Refunds',
          'Chargebacks',
          'Adjusted Gross',
          'Merchant Payouts',
          'DDB Commission',
          'Net To Site',
      ],
    ];

    {data &&
      data.data.map((data, index) =>
        csvData.push([
          data.city,
          data.credit_card_sale,
          data.site_credits,
          data.promos,
          data.gross_sale,
          data.tax_amount,
          data.credit_card_fee,
          data.refund_amount,
          data.chargebacks,
          data.adjusted_gross_sale,
          data.merchant_payouts,
          data.ddb_commission,
          data.net_to_site,
        ])
      )
    }

    this.setState({ csvData: csvData });
  };


  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Revenue Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="formParentID">
                    <ControlLabel>Deal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="dealType"
                      onChange={this.handleChange}
                      placeholder="select"
                      value={this.state.dealType}
                      >
                      <option value="">All</option>
                      <option value="offer">Offer</option>
                      <option value="products">Products</option>
                      <option value="auction">Auction</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"revenue-reports.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="13">Data up to the date: {(this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY')}</th>
                </tr>
                <tr>
                  <th>Market</th>
                  <th>Credit Card Sales</th>
                  <th>Site Credits</th>
                  <th>Promos</th>
                  <th>Gross Sale</th>
                  <th>Taxes</th>
                  <th>Credit Card Fee</th>
                  <th>Refunds</th>
                  <th>Chargebacks</th>
                  <th>Adjusted Gross</th>
                  <th>Merchant Payouts</th>
                  <th>DDB Commission</th>
                  <th>Net To Site</th>
                </tr>
              </thead>
              <tbody>
              {this.state.reportData.data ?
                    this.state.reportData.data.map((data, index) =>
                <tr key={index}>
                  <td>{data.city}</td>
                  <td>{data.credit_card_sale}</td>
                  <td>{data.site_credits}</td>
                  <td>{data.promos}</td>
                  <td>{data.gross_sale}</td>
                  <td>{data.tax_amount}</td>
                  <td>{data.credit_card_fee}</td>
                  <td>{data.refund_amount}</td>
                  <td>{data.chargebacks}</td>
                  <td>{data.adjusted_gross_sale}</td>
                  <td>{data.merchant_payouts}</td>
                  <td>{data.ddb_commission}</td>
                  <td>{data.net_to_site}</td>
                </tr>
                )
                :
                <tr><td colSpan="13">Data Not Found</td></tr>
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    reportData: state.reportReducer.reportData
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    getReport
  })
)(RevenueReports);


// WEBPACK FOOTER //
// ./src/app/views/admin/reports/RevenueReports.js